import { useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';

import DraftMenu from './Menus/DraftMenu';
import PlansMenu from './Menus/PlansMenu';
import BoardsMenu from './Menus/BoardsMenu';
import PartnersMenu from './Menus/PartnersMenu';
import DocumentsMenu from './Menus/DocumentsMenu';
import DashboardMenu from './Menus/DashboardMenu';
import PortfoliosMenu from './Menus/PortfoliosMenu';
import SignaturesMenu from './Menus/SignaturesMenu';
import SocietyDataMenu from './Menus/SocietyDataMenu';
import TransactionsMenu from './Menus/TransactionsMenu';
import EquityMarketMenu from './Menus/EquityMarketMenu';
import CustomLandingMenu from './Menus/CustomLandingMenu';
import CommunicationsMenu from './Menus/CommunicationsMenu';
import AdministrativesMenu from './Menus/AdministrativesMenu';

import { useExtendedMenu } from '../hooks/useExtendedMenu';

type ExtendedMenuProps = {
  societyId: string;
  userId: string | null;
};

function ExtendedMenu({ societyId, userId = null }: ExtendedMenuProps) {
  const { data, actions } = useExtendedMenu({ societyId, userId });

  const [activeKey, setActiveKey] = useState<string | null>(null);

  const {
    hasAccessCaptable,
    isSocietyHolding, // eslint-disable-line
    configuration,
    actualSociety,
    societyPermissions, // eslint-disable-line
    hasCustomLanding, // eslint-disable-line
    role, // eslint-disable-line
    user,
    isDemo,
    rolesValidation,
    isAdmin,
    isPartner,
    isBeneficiary,
    isInvestor,
    isRepresentant,
    isGuest, // eslint-disable-line
    isHolder, // eslint-disable-line
    isDirector,
    hasCustomLandingMenu,
    hasDashboardMenu,
    hasPartnersMenu,
    hasDraftsMenu,
    hasCommunicationsMenu,
    hasBoardMenu,
    hasSignaturesMenu,
    hasDocumentsMenu,
    hasSocietyDataMenu,
    hasPlansMenu,
    hasTransactionsMenu,
    hasEquityMarketMenu,
    hasPortfolioMenu,
    hasAdministrativeMenu,
  } = data;

  const { getBoardLinkByRole } = actions;

  const handleAccordionChange = (eventKey: string | null) => {
    setActiveKey(eventKey || '');
  };

  return (
    <Accordion
      id="main-menu__extended"
      className="pl-4 p-md-0 bg-transparent"
      activeKey={activeKey || ''}
      onSelect={handleAccordionChange}
    >
      {hasCustomLandingMenu && (
        <CustomLandingMenu
          order="0"
          societyId={societyId}
          isActive={activeKey === '0'}
        />
      )}

      {hasDashboardMenu && isAdmin && (
        <DashboardMenu
          order="0"
          societyId={societyId}
          isActive={activeKey === '0'}
        />
      )}

      {hasPartnersMenu && (
        <PartnersMenu
          order="1"
          societyId={societyId}
          isActive={activeKey === '1'}
          isAdmin={isAdmin}
          isPartner={isPartner}
          isInvestor={isInvestor}
          userId={userId || ''}
          hasAccessCaptable={hasAccessCaptable}
        />
      )}

      {hasPortfolioMenu && (
        <PortfoliosMenu
          order="2"
          societyId={societyId}
          isActive={activeKey === '2'}
        />
      )}

      {hasAdministrativeMenu && (isAdmin || isDirector) && (
        <AdministrativesMenu
          order="3"
          societyId={societyId}
          isDirector={isDirector}
          rolesValidation={rolesValidation}
          isActive={activeKey === '3'}
        />
      )}

      {hasBoardMenu && (isAdmin || isPartner || isRepresentant) && (
        <BoardsMenu
          order="4"
          societyId={societyId}
          isActive={activeKey === '4'}
          corporateId={actualSociety?.corporateId || ''}
          getBoardLinkByRole={getBoardLinkByRole}
        />
      )}

      {hasTransactionsMenu && isAdmin && (
        <TransactionsMenu
          order="5"
          societyId={societyId}
          isActive={activeKey === '5'}
        />
      )}

      {hasEquityMarketMenu && (
        <EquityMarketMenu
          order="12"
          societyId={societyId}
          isActive={activeKey === '12'}
        />
      )}

      {hasPlansMenu && (isAdmin || isBeneficiary) && (
        <PlansMenu
          order="6"
          societyId={societyId}
          isActive={activeKey === '6'}
          isAdmin={isAdmin}
          isBeneficiary={isBeneficiary}
          user={user}
        />
      )}

      {hasDraftsMenu && isAdmin && (
        <DraftMenu
          order="7"
          societyId={societyId}
          isActive={activeKey === '7'}
        />
      )}

      {hasSignaturesMenu && isAdmin && (
        <SignaturesMenu
          order="8"
          societyId={societyId}
          isActive={activeKey === '8'}
        />
      )}

      {hasDocumentsMenu && isAdmin && (
        <DocumentsMenu
          order="9"
          societyId={societyId}
          isActive={activeKey === '9'}
        />
      )}

      {hasSocietyDataMenu && isAdmin && (
        <SocietyDataMenu
          order="10"
          societyId={societyId}
          isActive={activeKey === '10'}
          isDemo={isDemo}
          configuration={configuration}
        />
      )}

      {hasCommunicationsMenu && isAdmin && (
        <CommunicationsMenu
          order="11"
          societyId={societyId}
          isActive={activeKey === '11'}
        />
      )}
    </Accordion>
  );
}

export default ExtendedMenu;
